import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClone } from "@fortawesome/pro-regular-svg-icons";
import { Tooltip } from "~/components/Tooltip";
import { useEffect, useState } from "react";
import { useCopyToClipboard } from "~/components/CopyToClipboard";

// // // //

/**
 * CopyAddressButton
 * Copies an address (tx hash / to address / from address in ExplorerLink)
 */
export function CopyAddressButton(props: { address: string }) {
    const { address } = props;

    // Setup CopyToClipboard hook w/ useState to dipslay "Copied" message
    // NOTE - we include the `hidden` state here to temporarily hide the tooltip while its content changes to prevent a misalignment bug
    const [copied, setCopied] = useState<boolean>(false);
    const [hidden, setHidden] = useState<boolean>(false);
    const [copyToClipboard] = useCopyToClipboard(() => {
        setCopied(true);
    });

    useEffect(() => {
        if (copied === true) {
            // Hide the tooltip content
            setHidden(true);

            // Set `Copied!` text back to `Copy Address`
            setTimeout(() => {
                setCopied(false);
            }, 1000);

            // Unhide the tooltip content after 50ms
            setTimeout(() => {
                setHidden(false);
            }, 50);
        }
    }, [copied]);

    const message: string = copied ? "Copied!" : "Copy Address";

    return (
        <Tooltip
            placement="top"
            tooltipContent={
                hidden ? null : (
                    <div className="w-max px-2 py-0.5 text-center">
                        <p className="whitespace-nowrap text-xs font-light">
                            {message}
                        </p>
                    </div>
                )
            }
        >
            {({ setTriggerRef }) => (
                <button
                    ref={setTriggerRef}
                    className="text-muted-foreground hover:text-muted-foreground-hover ml-2 -mt-1.25"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        copyToClipboard(address);
                    }}
                >
                    {!copied && (
                        <FontAwesomeIcon icon={faClone} className="h-3" />
                    )}
                    {copied && (
                        <FontAwesomeIcon
                            icon={faCheck}
                            className="h-3 text-emerald-700"
                        />
                    )}
                </button>
            )}
        </Tooltip>
    );
}
